import { render, staticRenderFns } from "./telaInicial1.vue?vue&type=template&id=2fe5801e&scoped=true&"
import script from "./telaInicial1.vue?vue&type=script&lang=js&"
export * from "./telaInicial1.vue?vue&type=script&lang=js&"
import style0 from "./telaInicial1.vue?vue&type=style&index=0&id=2fe5801e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe5801e",
  null
  
)

export default component.exports